<template>
  <div class="row">
    <div class="col-sm-7">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <div class="">
            <label>Datum</label>
            <fg-input placeholder="Datum" type="datetime-local" step=1 v-model="date"
              :error="valErrors['date'] ? valErrors['date'][0] : null" />
          </div>
          <div class="mb-2" v-if="warehouses.length > 1">
            <label>Lager</label>
            <multiselect v-model="order.warehouse" :options="warehouses" track-by="id" label="short_name"
              placeholder="Lager auswählen" @input="selectWarehouse" />
          </div>
          <div class="row">
            <div class="col-sm-6">
              <label>Lieferant</label>
              <multiselect v-model="order.supplier" :options="suppliers" track-by="id" label="name"
                placeholder="Lieferant auswählen" @input="selectSupplier" />
            </div>
            <div class="col-sm-6">
              <label>Empfänger E-Mail Adresse</label>
              <fg-input placeholder="Empfänger E-Mail Adresse" type="text" v-model="order.email"
                :error="valErrors['email'] ? valErrors['email'][0] : null" />
            </div>
          </div>
          <div class="mb-2"
            v-if="!is_repeat_order && order.supplier && order.supplier.contact_people && order.supplier.contact_people.length">
            <label>Kontaktperson</label>
            <multiselect v-model="order.contact_person" :options="order.supplier.contact_people" track-by="id"
              label="fullName" @input="selectContactPerson" />
            <div class="text-danger invalid-feedback" style="display: block;" v-if="valErrors['file']">
              {{ valErrors['file'][0] }}
            </div>
          </div>

          <div class="mb-4">
            <label>E-Mail Betreff</label>
            <fg-input placeholder="E-Mail Betreff" type="text" v-model="order.email_subject"
              :error="valErrors['subject'] ? valErrors['subject'][0] : null" />
          </div>
          <div>
            <l-checkbox v-model="order.append_prices">Einkaufspreise übermitteln</l-checkbox>
          </div>
          <hr>
          <label class="label-title">Produkte bestellen</label>
          <div>
            <multiselect v-model="productCategory" :options="sortedProductCategories" track-by="id"
              placeholder="Produktkategorie auswählen" label="name" selectLabel="" />
          </div>
          <div class="form-group has-label" style="margin-top: 1rem;">
            <multiselect v-model="product"
              :options="productCategory ? (productCategory.name === 'Alle' ? allProducts : productCategory.products) : []"
              track-by="id"
              :custom-label="({ product }) => `${product.name}  ${product.referenznummer ? ' | ' + product.referenznummer : ''}`"
              placeholder="Produkt auswählen" selectLabel="" @input="productSelected">
              <template slot="option" slot-scope="props">
                <div>
                  <strong style="font-size: 1.15em">{{ props.option.product.name }}<span
                      v-if="props.option.referenznummer"> ({{ props.option.referenznummer }})</span><span
                      v-if="props.option.product.pzn"> | PZN: {{ props.option.product.pzn }}</span></strong><br>
                  <div style="margin-top: 0.5em">
                    <span style="font-size: 0.9em">
                      P: {{ props.option.price | priceFromCentEuro }} | L: {{ props.option.quantity || 0 }} | B: {{
                        props.option.product.orders.length ? props.option.product.orders[0].ordered_quantity : 0 }}
                    </span>
                    <template v-if="props.option.soll_menge">
                      <br>
                      <span style="font-size: 0.9em">
                        Lager Sollmenge: {{ props.option.soll_menge }}
                      </span>
                    </template>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div class="row">
            <div class="col-sm-2 form-group-vertical">
              <fg-input label="Menge" type="number" v-model="quantity" @input="validateQuantity" />
            </div>
            <div class="col-sm-4 form-group-vertical">
              <fg-input label="EAN / Artikelnummer" v-model="referenznummer" />
            </div>
            <div class="col-sm-5 form-group-vertical">
              <fg-input label="Preis">
                <p class="form-control-static text-right">
                  {{ product ? (product.price * quantity) : '' | priceFromCentEuro }}
                </p>
              </fg-input>
            </div>
            <div class="col-sm-1 text-right">
              <button class="btn btn-fill btn-primary" style="margin-top: 2em;" @click.prevent="addProduct">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div v-if="order.products.length" style="margin-bottom: 2em;">
            <div class="row" v-for="addedProduct in order.products" :key="addedProduct.product.product.id">
              <div class="col-sm-6">
                {{ addedProduct.product.product.name }}<span v-if="addedProduct.referenznummer"> ({{
                  addedProduct.referenznummer }})</span>
              </div>
              <div class="col-sm-3">
                <input type="number" class="form-control valid" v-model="addedProduct.quantity">
              </div>
              <div class="col-sm-2 text-right">

                {{ (addedProduct.quantity * (is_repeat_order ? addedProduct.price : addedProduct.product.price))
                  |
                priceFromCentEuro }}
              </div>
              <div class="col-sm-1 text-right">
                <button class="btn btn-fill btn-danger btn-sm" style="vertical-align: sub;"
                  @click.prevent="deleteProduct(addedProduct)">
                  <i class="fa fa-close"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-9">
                <div v-if="order.supplier.min_order_sum > orderSum" style="padding-top: 1rem;">
                  <l-alert type="danger">
                    <strong>Mindestbestellwert: {{ order.supplier.min_order_sum | priceFromCentEuro }}</strong><br>
                    Fügen Sie noch Produkte im Wert von mindestens {{ (order.supplier.min_order_sum - orderSum) |
                      priceFromCentEuro }} hinzu
                  </l-alert>
                </div>
              </div>
              <div class="col-sm-2 text-right">
                <div style="border-top: 4px double; padding-top: 1rem;">{{ orderSum | priceFromCentEuro }}</div>
              </div>
              <div class="col-sm-1"></div>
            </div>
          </div>
          <hr>
          <div class="form-group-vertical has-label">
            <label class="d-flex justify-content-between">
              <div>Email Bestelltext</div>
              <div>
                <button class="btn btn-fill btn-sm" :class="editMode ? 'btn-success' : 'btn-info'"
                  @click.prevent="editMode = !editMode">
                  <i class="fa fa-xs" :class="editMode ? 'fa-check' : 'fa-edit'"></i>
                </button>
              </div>
            </label>
            <div v-text="emailTextFormatted" style="white-space: break-spaces;" v-show="!editMode"></div>
            <textarea class="form-control" v-model="emailText" rows="5" v-show="editMode"></textarea>

            <button v-if="!authUser.use_sig_to_all" @click="addSignatureHandler" class="btn btn-fill btn-sm">
              Signatur einfügen
            </button>
            <div style="margin-top: 1rem;">
              <small class="text-muted text-sm">Der Textbaustein <strong>REPLACE_PRODUCTS</strong> wird automatisch mit
                einer Liste der zu bestellenden Produkten ersetzt.</small>
            </div>
          </div>
          <fg-input label="Kommentar">
            <textarea class="form-control" v-model="order.comment" rows="3"></textarea>
          </fg-input>
          <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
        </form>
      </card>
    </div>
    <div class="col-sm-5">
      <transition name="el-fade-in-linear">
        <card v-if="warnschwelleProducts.length">
          <table class="table table-striped ">
            <thead>
              <tr>
                <th>Produkt</th>
                <th>Auf Lager</th>
                <th>Warnschwelle</th>
                <th>Lager Sollmenge</th>
                <th>Offene Bestellungen</th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="warnschwelleProducts.length">
              <tr v-for="product in warnschwelleProductsSorted" :key="product.id"
                :class="product.hasBeenAdded ? 'has-been-added' : ''">
                <td>
                  <router-link :to="`/products/${product.product.id}`">
                    {{ product.product.name }}
                  </router-link>
                  <span v-if="product.soll_menge">
                    ({{ product.soll_menge - product.quantity }})
                  </span>
                </td>
                <td class="text-right">{{ product.quantity || 0 }}</td>
                <td class="text-right">{{ product.warnschwelle }}</td>
                <td class="text-right">{{ product.soll_menge }}</td>
                <td class="text-right">{{ product.ordered_quantity || 0 }}</td>
                <td class="text-right">
                  <button class="btn btn-primary" :disabled="product.hasBeenAdded"
                    @click.prevent="addWarnschwelleProduct(product)">
                    <i class="fas fa-plus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </card>
      </transition>
    </div>
  </div>
</template>

<script>
import LAlert from 'src/components/Alert'
import formatEmailText from './format-email-text'
import moment from 'moment';

export default {
  components: { LAlert },
  props: {
    valErrors: null,
    initOrder: null,
    submitText: null,
    initProduct: null,
    settings: Object
  },
  data() {
    return {
      url: window.location.href,
      order: this.initOrder,
      productCategory: null,
      date: window.location.href.includes('create') ? moment().format('YYYY-MM-DD HH:mm:ss') : this.initOrder.date ? moment(this.initOrder.date).format('YYYY-MM-DD HH:mm:ss') : moment(this.initOrder.created_at).format('YYYY-MM-DD HH:mm:ss'),
      product: null,
      suppliers: [],
      productCategories: [],
      products: [],
      warnschwelleProducts: [],
      warehouses: [],
      quantity: '',
      referenznummer: '',
      warehouseText: '',
      supplierText: '',
      editMode: false,
      emailText: '',
      isFirst: true,
      signaturText: '',
      authUser: '',
      addSignature: false,
      allProducts: []
    }
  },
  watch: {
    initOrder: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.order = {
            ...newValue,
          };
          this.email_subject = newValue.email_subject || (this.settings ? this.settings.email_subject : '');
        }
      },
    },
  },

  methods: {
    validateQuantity() {
      if (this.quantity !== null && isNaN(this.quantity) || this.quantity < 0) {
        this.quantity = null;
      }
    },
    selectContactPerson(contactPerson) {
      if (contactPerson) {
        this.order.email = contactPerson.email
        this.order.contact_person_id = contactPerson.id
      } else {
        this.order.email = ''
        this.order.contact_person_id = null
      }
    },
    addSignatureHandler() {
      this.authUser.use_sig_to_all = true
      this.addSignature = true
    },
    submit() {
      this.order.supplier_id = this.order.supplier ? this.order.supplier.id : null
      this.order.date = this.date
      this.order.email_text = this.emailTextFormattedFinal
      this.$emit('submit', this.order)
    },
    async fetchProducts(supplierId) {
      this.$http.get(`/suppliers/${supplierId}/products`).then(({ data }) => {
        this.allProducts = data;
        this.productCategories = Object.values(
          data.reduce((sum, product) => {
            if (!sum.hasOwnProperty(product.product.product_category_id)) {
              sum[product.product.product_category_id] = {
                id: product.product.product_category_id,
                name: product.product.product_category ? product.product.product_category.name : 'Nicht zugeordnet',
                products: []
              }
            }
            sum[product.product.product_category_id].products.push(product)
            return sum
          }, {})
        )
        this.productCategories.push({ id: 1, name: 'Alle', type: 'Alle' })
        if (this.isFirst) {
          if (this.initProduct) {
            this.product = data.find(({ product }) => +product.id === +this.initProduct)
            if (this.product.soll_menge) {
              this.quantity = this.product.soll_menge - this.product.quantity
            }
          }
          this.isFirst = false
        }
      })
    },
    fetchWarnschwelleProducts(supplierId, warehouseId) {
      const exclude = this.order.id ? `&exclude=${this.order.id}` : ''
      this.$http.get(`/suppliers/${supplierId}/products/to_order?warehouse=${warehouseId}${exclude}`).then(({ data }) => {
        this.warnschwelleProducts = data.map(product => {
          const existsInOrder = this.order.products.findIndex(addedProduct => +addedProduct.product.product.id === +product.id) > -1
          product.hasBeenAdded = existsInOrder
          return product
        })
      })
    },
    selectSupplier(supplier) {
      this.product = null
      this.order.products = []
      if (supplier) {
        this.fetchProducts(this.order.supplier.id)
        this.order.email = supplier.email
        if (this.order.warehouse_id) {
          this.fetchWarnschwelleProducts(this.order.supplier.id, this.order.warehouse_id)
        }
      } else {
        this.order.email = ''
      }

      this.setEmailTextSupplier()
    },
    selectWarehouse(warehouse) {
      this.order.warehouse_id = warehouse ? warehouse.id : null
      if (warehouse && this.order.supplier) {
        this.fetchWarnschwelleProducts(this.order.supplier.id, warehouse.id)
      } else {
        this.products = []
        this.warnschwelleProducts = []
      }

      this.setEmailTextWarehouse()
    },
    setEmailTextSupplier() {
      if (this.order.supplier) {
        this.supplierText = this.order.supplier.order_email_text
      } else {
        this.supplierText = ''
      }
      this.getEmailtext()
    },
    setEmailTextWarehouse() {
      if (this.order.warehouse) {
        this.warehouseText = this.order.warehouse.order_email_text
      } else {
        this.warehouseText = ''
      }
      this.getEmailtext()
    },
    addProduct() {
      const index = this.order.products.findIndex(({ product }) => +product.id === +this.product.id)
      if (index >= 0) {
        this.order.products[index].quantity += +this.quantity
      } else {
        console.log('addProduct', this.product)
        this.order.products.push({
          product: this.product,
          quantity: +this.quantity,
          referenznummer: this.referenznummer,
          price: this.is_repeat_order ? this.product.price : this.product.price
        })
        this.markWarnschwellenProduct(this.product.product.id, true)
      }
      this.product = null
      this.quantity = ''
      this.referenznummer = null
    },
    addWarnschwelleProduct(product) {
      const quantity = product.soll_menge - product.quantity - product.ordered_quantity
      const index = this.order.products.findIndex(addedProduct => +addedProduct.product.product.id === product.product.id)
      if (index >= 0) {
        this.order.products[index].quantity += (quantity || 1)
      } else {
        this.order.products.push({
          product: product,
          quantity: (quantity || 1),
          referenznummer: product.referenznummer || null,
        })
      }
      product.hasBeenAdded = true
    },
    deleteProduct(productToDelete) {
      const index = this.order.products.findIndex(({ product }) => {
        return product.product.id === productToDelete.product.product.id
      })
      this.markWarnschwellenProduct(productToDelete.product.product.id, false)
      this.order.products.splice(index, 1)
    },
    markWarnschwellenProduct(productToCheck, hasBeenAdded) {
      const warnschwelleProduct = this.warnschwelleProducts.find(({ product }) => {
        return product.id === productToCheck
      })
      if (warnschwelleProduct) {
        warnschwelleProduct.hasBeenAdded = hasBeenAdded
      }
    },
    productSelected(product) {
      this.referenznummer = product ? product.referenznummer : null
    },
    getEmailtext() {
      if (!this.settings) return;

      if (!this.authUser.use_sig_to_all) {
        this.emailText = `${this.settings.order_email_default_text || ''} \n\n${this.supplierText || ''}\n\n${this.settings.order_email_product_text || ''}\nREPLACE_PRODUCTS\n${this.warehouseText || ''}\n\n${this.settings.order_email_end_text || ''}`;
      } else {
        this.emailText = `${this.settings.order_email_default_text || ''} \n\n${this.supplierText || ''}\n\n${this.settings.order_email_product_text || ''}\nREPLACE_PRODUCTS\n${this.warehouseText || ''}\n\n${this.settings.order_email_end_text || ''} \n\n${this.authUser.signature}`;
      }
    }
  },
  computed: {
    is_repeat_order() {
      return !!this.order.id;
    },
    sortedProductCategories() {
      return this.productCategories.sort((a, b) => a.name.localeCompare(b.name));
    },
    emailTextFormatted() {
      if (!this.emailText) return null
      if (this.addSignature) {
        this.emailText += `\n\n${this.authUser.signature}`;
      }
      const productsMapped = this.order.products.map(product => {
        const pzn = product.product.product.pzn ? `${product.product.product.pzn} | ` : ''
        const referenznummer = product.referenznummer ? `${product.referenznummer} | ` : ''
        let bla = `${product.quantity} x ${pzn}${referenznummer}${product.product.product.name}`
        if (this.order.append_prices) {
          bla += ` (à ${this.$options.filters.priceFromCentEuro(product.product.price)})`
        }
        return bla
      })
      return formatEmailText(productsMapped, this.emailText)
    },
    emailTextFormattedFinal() {
      if (!this.emailText) return null;

      const tableHeader = `
    <thead contenteditable="false">
      <tr contenteditable="false">
        <th contenteditable="false" style="border: 1px solid black;">Menge</th>
        <th contenteditable="false" style="border: 1px solid black;">PZN</th>
        <th contenteditable="false" style="border: 1px solid black;">Referenznummer</th>
        <th contenteditable="false" style="border: 1px solid black;">Produkt</th>
        <th contenteditable="false" style="border: 1px solid black;">Preis</th>
      </tr>
    </thead>
  `;

      const tableBody = this.order.products
        .map((product) => {
          const pzn = product.product.product.pzn ? `${product.product.product.pzn}` : '';
          const referenznummer = product.referenznummer ? `${product.referenznummer}` : '';
          let row = `
      <tr contenteditable="false">
        <td contenteditable="false" style="text-align:center; border: 1px solid black;">${product.quantity}</td>
        <td contenteditable="false" style="text-align:center; border: 1px solid black;">${pzn}</td>
        <td contenteditable="false" style="text-align:center; border: 1px solid black;">${referenznummer}</td>
        <td contenteditable="false" style="text-align:center; border: 1px solid black;">${product.product.product.name}</td>
    `;
          if (this.order.append_prices) {
            row += `<td contenteditable="false" style="text-align:center; border: 1px solid black;">${this.$options.filters.priceFromCentEuro(product.product.price)}</td>`;
          }
          row += `</tr>`;
          return row;
        })
        .join('');

      const htmlTable = `
    <table contenteditable="false" style="border-collapse: collapse !important; width: 100% !important; border: 1px solid black !important;font-size:10px !important;">
      ${tableHeader}
      <tbody contenteditable="false">${tableBody}</tbody>
    </table>
  `;

      const cleanHtmlTable = htmlTable.replace(/(\r\n|\n|\r)/gm, '');

      return this.emailText.replace('REPLACE_PRODUCTS', cleanHtmlTable);
    },
    orderSum() {
      return this.order.products.reduce((sum, product) => {
        console.log('orderSum', product.product.price)
        const price = this.is_repeat_order ? product.price : (product.product.price || 0);
        const quantity = product.quantity || 0;
        return sum + (price * quantity);
      }, 0);
    },
    warnschwelleProductsSorted() {
      return [...this.warnschwelleProducts].sort((productA, productB) => {
        return (productA.hasBeenAdded === productB.hasBeenAdded) ? 0 : productA.hasBeenAdded ? 1 : -1
      })
    }
  },
  created() {
    const queryParams = new URLSearchParams(window.location.search);
    const orderId = queryParams.get('orderId');
    if (orderId) {
      this.order = this.initOrder;
    } else (error) => {
      console.error('Fehler beim Abrufen der Bestellung:', error);
      this.$notify({
        message: 'Fehler beim Laden der Bestelldaten.',
        type: 'error',
      });
    }

    setTimeout(() => {
      this.getEmailtext();

      if (this.order.supplier) {
        this.fetchProducts(this.order.supplier.id)
        this.fetchWarnschwelleProducts(this.order.supplier.id, this.order.warehouse_id)
      }
    }, 700);

    this.$http.get('/suppliers').then(({ data }) => { this.suppliers = data })
    this.$http.get('/auth/user').then(({ data }) => {
      this.authUser = data
    })
    this.$http.get('/warehouses').then(({ data }) => {
      if (data.length === 1) {
        this.order.warehouse_id = data[0].id
      }
      this.warehouses = data
    })
  },
  watch: {
    order: {
      handler(newValue) {
        if (newValue.warehouse_id) {
          this.order.warehouse_id = newValue.warehouse_id
        }
      }
    }
  }
}
</script>

<style scoped>
.has-been-added {
  opacity: 0.5;
}

</style>
